export default __webpack_public_path__ + "static/media/androidButton.ef8b1a78.svg";